import React, { useEffect, useState } from "react";
import "./DettyDecember.css";
import Modal from "./Modal"; // your modal component

export default function DettyDecember({ setIsAnyModalActive }) {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalConfig, setModalConfig] = useState(null);
  const [actionLoading, setActionLoading] = useState(false);

  // Fetch bookings
  const fetchBookings = async (showSpinner = false) => {
    if (showSpinner) setLoading(true);

    try {
      const res = await fetch("https://admin-new.lasgidirestaurant.com/php/get-detty-bookings.php");
      const data = await res.json();
      const sortedBookings = data.sort((a, b) => a.id - b.id);
      setBookings(sortedBookings);
    } catch (err) {
      console.error("Error fetching bookings:", err);
    } finally {
      if (showSpinner) setLoading(false);
    }
  };

  useEffect(() => {
    fetchBookings(true);
    const interval = setInterval(() => fetchBookings(false), 5000);
    return () => clearInterval(interval);
  }, []);

  // Delete booking
  const deleteBooking = async (id) => {
    setActionLoading(true); // start spinner
    setModalConfig(null);
    if (setIsAnyModalActive) setIsAnyModalActive(false);

    try {
      const res = await fetch("https://admin-new.lasgidirestaurant.com/php/delete-detty-booking.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });
      const data = await res.json();
      if (data.success) {
        fetchBookings(false);
      }
    } catch (err) {
      console.error("Server error:", err);
    } finally {
      setActionLoading(false); // stop spinner
    }
  };

  // Open delete confirmation modal
  const openDeleteModal = (booking) => {
    setModalConfig({
      title: "Delete Booking",
      content: (
        <div className="delete-modal-heading">
          <p>
            Are you sure you want to delete the booking for{" "}
            <strong>{booking.name}</strong>?
          </p>
        </div>
      ),
      onConfirm: () => deleteBooking(booking.id),
      type: "CONFIRM_MODAL",
    });
    if (setIsAnyModalActive) setIsAnyModalActive(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const closeModal = () => {
    setModalConfig(null);
    if (setIsAnyModalActive) setIsAnyModalActive(false);
  };

  return (
    <div className="dd-admin-wrapper">
      <h2>Detty December 2025 Bookings</h2>

      {(loading || actionLoading) && (
        <div className="spinner-overlay">
          <div className="spinner"></div>
        </div>
      )}

      {!loading && (
        <table className="dd-table">
          <thead>
            <tr>
              <th>S/N</th>
              <th>Name</th>
              <th>Phone</th>
              <th>Email</th>
              <th>Adults</th>
              <th>Children</th>
              <th>Days Attending</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {bookings.length === 0 ? (
              <tr>
                <td colSpan="7" className="dd-no-data">
                  No bookings found.
                </td>
              </tr>
            ) : (
              bookings.map((b, index) => {
                const num_adults = Number(b.number_of_adults);
                const num_children = Number(b.number_of_children);

                return (
                  <tr key={b.id}>
                    <td>{index + 1}</td>
                    <td>{b.name}</td>
                    <td>{b.phone}</td>
                    <td>{b.email}</td>
                    <td>
                      {num_adults} {num_adults === 1 ? "adult" : "adults"}
                    </td>
                    <td>
                      {num_children} {num_children === 1 ? "child" : "children"}
                    </td>

                    <td>
                      {b.days_attending.split(",").map((day) => {
                        let dayClass = "";
                        switch (day.trim()) {
                          case "24th":
                            dayClass = "dd-day-24";
                            break;
                          case "25th":
                            dayClass = "dd-day-25";
                            break;
                          case "26th":
                            dayClass = "dd-day-26";
                            break;
                          default:
                            dayClass = "dd-days-badge";
                        }
                        return (
                          <span
                            key={day}
                            className={`dd-days-badge ${dayClass}`}
                          >
                            {day.trim()}
                          </span>
                        );
                      })}
                    </td>
                    <td className="dd-action-column">
                      <button
                        className="dd-delete-btn"
                        onClick={() => openDeleteModal(b)}
                      >
                        <i className="fa fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      )}

      {/* Delete Confirmation Modal */}
      {modalConfig && (
        <Modal
          title={modalConfig.title}
          onClose={closeModal}
          showCancel={true}
          showSubmitButton={true}
          submitButtonText={actionLoading ? "Deleting..." : "Delete"}
          onSubmit={async (e) => {
            e.preventDefault();
            if (modalConfig.onConfirm) await modalConfig.onConfirm();
          }}
        >
          {modalConfig.content}
        </Modal>
      )}
    </div>
  );
}
